import {
  compactFormat,
  dataLabelsCompact,
  dataLabelsDecimals,
  dataLabelsSizes,
  dataLabelsTopEntries,
  dimension,
  dimensionSelector,
  legendPosition,
  palette,
  primaryMetric,
  primaryMetricSelector,
  showDataLabels,
  showDataLabelsLegend,
  showItems,
} from "@/settings/charts/settingsDictionary";
import { FAMILY } from "@/settings/widgetFamilies";
import { Config } from "@/types/charts";

export default <Config>{
  family: [FAMILY.RELATIONSHIPS],
  recommendedFamily: [FAMILY.RELATIONSHIPS],
  title: "Bubble Chart",
  defaultHeight: 6,
  dataModes: ["project", "explore", "dual"],
  controls: [dimension, { ...primaryMetric, metricName: "xAxis" }],
  settings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    xAxis: {
      default: "ctr",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 2,
    },
    yAxis: {
      default: "cpm",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 3,
    },
    decompositionMetric: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric (bubble color)",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric (bubble size)",
      dictionary: "displayMetrics",
      gridPosition: [0, 1],
      tooltipOrder: 1,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [1, 1],
      forAxis: "xAxis",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "yAxis",
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
    primaryMetricSelector: { ...primaryMetricSelector, gridPosition: [7, 0] },
  },
  planSettings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    xAxis: {
      default: "ctr",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 2,
    },
    yAxis: {
      default: "cpm",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 3,
    },
    decompositionMetric: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric (bubble color)",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    displayMetric: {
      default: "channel_budget",
      type: "select",
      label: "Display Metric (bubble size)",
      dictionary: "displayMetrics",
      gridPosition: [0, 1],
      tooltipOrder: 1,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [1, 1],
      forAxis: "xAxis",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "yAxis",
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
    primaryMetricSelector: { ...primaryMetricSelector, gridPosition: [7, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [8, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [8, 1] },
    dataLabelField: {
      default: "decompositionMetric",
      type: "select",
      label: "Data Label Field",
      dictionary: "bubbleLabelFields",
      gridPosition: [9, 0],
    },
    dataLabelsTopEntries: { ...dataLabelsTopEntries, gridPosition: [9, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [10, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [10, 1] },
    showDataLabelsLegend: { ...showDataLabelsLegend, gridPosition: [11, 0] },
  },
  planExploreSettings: {
    palette,
    showItems: { ...showItems, gridPosition: [3, 0] },
    legendPosition: { ...legendPosition, gridPosition: [4, 0] },
    compactFormat: { ...compactFormat, gridPosition: [5, 0] },
    xAxis: {
      default: "ctr",
      type: "select",
      label: "Horizontal Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [1, 0],
      tooltipOrder: 2,
    },
    yAxis: {
      default: "cpm",
      type: "select",
      label: "Vertical Axis Metric",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 3,
    },
    decompositionMetric: {
      default: "channel",
      type: "select",
      label: "Decomposition Metric (bubble color)",
      dictionary: "dimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    displayMetric: {
      default: "spend",
      type: "select",
      label: "Display Metric (bubble size)",
      dictionary: "displayMetrics",
      gridPosition: [0, 1],
      tooltipOrder: 1,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [1, 1],
      forAxis: "xAxis",
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [2, 1],
      forAxis: "yAxis",
    },
    dimensionSelector: { ...dimensionSelector, gridPosition: [6, 0] },
    primaryMetricSelector: { ...primaryMetricSelector, gridPosition: [7, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [8, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [8, 1] },
    dataLabelField: {
      default: "decompositionMetric",
      type: "select",
      label: "Data Label Field",
      dictionary: "bubbleLabelFields",
      gridPosition: [9, 0],
    },
    dataLabelsTopEntries: { ...dataLabelsTopEntries, gridPosition: [9, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [10, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [10, 1] },
    showDataLabelsLegend: { ...showDataLabelsLegend, gridPosition: [11, 0] },
  },
  planDualSettings: {
    palette,
    xAxisSource: {
      default: "plan",
      dictionary: "metricSources",
    },
    yAxisSource: {
      default: "explore",
      dictionary: "metricSources",
    },
    decompositionMetric: {
      default: "channel",
      type: "select",
      label: "Grouping Dimension (Project + Explore)",
      dictionary: "dualDimensionMetrics",
      apiParameter: "dimension",
      gridPosition: [0, 0],
      tooltipOrder: 0,
    },
    displayMetric: {
      default: "channel_budget",
      type: "select",
      label: "Display Metric (bubble size, Plan)",
      dictionary: "displayMetrics",
      gridPosition: [2, 0],
      tooltipOrder: 1,
    },
    xAxis: {
      default: "ctr",
      type: "select",
      label: "Primary Metric (X axis)",
      dictionary: "displayMetrics",
      sourceFrom: "xAxisSource",
      gridPosition: [3, 0],
      tooltipOrder: 2,
    },
    xAxisTitle: {
      default: "",
      type: "text",
      label: "Horizontal Axis Title",
      gridPosition: [3, 1],
      forAxis: "xAxis",
    },
    yAxis: {
      default: "cpm",
      type: "select",
      label: "Secondary Metric (Y axis)",
      dictionary: "displayMetrics",
      sourceFrom: "yAxisSource",
      gridPosition: [4, 0],
      tooltipOrder: 3,
    },
    yAxisTitle: {
      default: "",
      type: "text",
      label: "Vertical Axis Title",
      gridPosition: [4, 1],
      forAxis: "yAxis",
    },
    legendPosition: { ...legendPosition, gridPosition: [5, 0] },
    compactFormat: { ...compactFormat, gridPosition: [6, 0] },
    showDataLabels: { ...showDataLabels, gridPosition: [7, 0] },
    dataLabelsSizes: { ...dataLabelsSizes, gridPosition: [7, 1] },
    dataLabelsCompact: { ...dataLabelsCompact, gridPosition: [8, 0] },
    dataLabelsDecimals: { ...dataLabelsDecimals, gridPosition: [8, 1] },
  },
};
